import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { CourseSubscriptionsDTO } from "../../schema/CourseSubscriptions/CourseSubscriptionsDTO";
import { CourseMatchDTO } from "../../schema/UserCourse/CourseMatchDTO";
import { CourseSubscriptionDTO } from "../../schema/UserCourse/CourseSubscriptionDTO";
import { OriginTypeEnumDTO } from "../../schema/UserCourse/OriginTypeEnumDTO";
import { TrackingLogInsertDTO } from "../../schema/UserCourse/TrackingLogInsertDTO";
import { UserCourseProgressionDTO } from "../../schema/UserCourse/UserCourseProgressionDTO";
import { UserCourseProgressionFilterDTO } from "../../schema/UserCourse/UserCourseProgressionFilterDTO";

@Injectable({
    providedIn: "root"
})
export class ApiUserCoursesService {
    private relativePath: string;

    constructor(private httpClient: HttpClient) {
        this.relativePath = `${environment.userCourses.url}/api/v1/UserCourses/user`;
    }

    public GetMatchByUserId(userId: string): Observable<CourseMatchDTO[]> {
        return this.httpClient.get<CourseMatchDTO[]>(`${this.relativePath}/${userId}/course/match`);
    }

    public RegisterUserIntoCourse(
        userId: string,
        courseId: string,
        type?: OriginTypeEnumDTO
    ): Observable<CourseSubscriptionDTO> {
        let params: HttpParams = new HttpParams();

        if (type) params = params.set("type", type.toString());
        else params = params.set("type", OriginTypeEnumDTO.Himself.toString());

        return this.httpClient.post<CourseSubscriptionDTO>(`${this.relativePath}/${userId}/course/${courseId}`, null, {
            params: params
        });
    }

    public Get(filters: UserCourseProgressionFilterDTO): Observable<GetDataDTO<UserCourseProgressionDTO>> {
        let params = new HttpParams().set("skip", filters.skip.toString()).set("take", filters.take.toString());

        if (filters.userId) params = params.append("UserId", filters.userId);
        if (filters.courseIds?.length > 0) filters.courseIds.forEach((id) => (params = params.append("courseIds", id)));

        return this.httpClient.get<GetDataDTO<UserCourseProgressionDTO>>(
            `${environment.userCourses.url}/api/v1/progressions`,
            {
                params: params
            }
        );
    }

    public GetCourseSubscriptionsByCourseId(
        courseId: string,
        skip = 0,
        take = 10,
        userId?: string
    ): Observable<GetDataDTO<CourseSubscriptionsDTO>> {
        let params: HttpParams = new HttpParams();
        params = params.set("skip", skip.toString());
        params = params.set("take", take.toString());
        if (userId) params = params.set("userId", userId.toString());

        return this.httpClient.get<GetDataDTO<CourseSubscriptionsDTO>>(
            `${environment.userCourses.url}/api/v1/Courses/${courseId}`,
            { params: params }
        );
    }

    public countCourseSubscriptionsByCourseId(courseId: string, onlyActive: boolean): Observable<number> {
        const param = new HttpParams().set("onlyActive", onlyActive.toString());
        return this.httpClient.get<number>(
            `${environment.userCourses.url}/api/v1/Courses/${courseId}/course-subscriptions/count`,
            {
                params: param
            }
        );
    }

    public GetCheckSubscriptionAvailable(courseId: string, userId?: string): Observable<any> {
        return this.httpClient.get<any>(
            `${environment.userCourses.url}/api/v1/UserCourses/user/${userId}/course/${courseId}/checkSubscriptionAvailable`
        );
    }

    public TrackingLog(courseId: string, lessonId: string, examId: string): Observable<any> {
        return this.httpClient.post<TrackingLogInsertDTO>(`${environment.userCourses.url}/api/TrackingLog`, {
            courseId: courseId,
            lessonId: lessonId,
            examId: examId
        } as TrackingLogInsertDTO);
    }
}
